import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue, fromCoolingCap } from '../../utils/utility';

export class AirHandlingUnitDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getAHUData() {
    return this.formRef.getFormData(['cooling_capacity']);
  }

  render() {
    const {
      name,
      type,
      cooling_capacity,
      unit,
      power_required,
      description,
      image,
    } = this.props.ahu;

    const { t, ref, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="air-conditioning-air-handling-unit-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-air-handling-unit-type"
          field="type"
          componentClass="select"
          label={t('type')}
          placeholder={t('type')}
          value={type}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type, 'ahu'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-air-handling-unit-cooling-capacity"
          field="cooling_capacity"
          type="number"
          label={t('cooling capacity')}
          placeholder="12"
          value={fromCoolingCap(cooling_capacity, unit)}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'cooling_capacity')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-air-handling-unit-unit"
          field="unit"
          componentClass="select"
          label={t('unit')}
          value={unit}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.units.map(unit => this.renderOption(unit, 'ahu'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-air-handling-unit-power-required"
          field="power_required"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-air-handling-unit-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

AirHandlingUnitDetail.defaultProps = {
  ahu: {},
};

const mapStateToProps = state => ({
  types: state.reference.ac.ahuTypes,
  units: state.reference.ac.coolingCapacityUnit,
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    null,
    null,
    { withRef: true },
  )(AirHandlingUnitDetail),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/AirHandlingUnitDetail.js